import type { TileConcreteDisplayProps } from '../../../types/rendering.js';
import { CanvasCircleRenderer } from '../renderers/CanvasCircleRenderer.js';

export const CanvasCircleDisplay = (props: TileConcreteDisplayProps) => {
  const {
    center: { x, y },
    fillColor,
    width,
    value,
    name,
    truncationMode,
    labelsDisplay,
  } = props;
  const halfWidth = width / 2;

  return (
    <CanvasCircleRenderer
      x={x}
      y={y}
      name={name}
      value={value}
      radius={halfWidth}
      fillColor={fillColor}
      strokeColor="transparent"
      truncationMode={truncationMode}
      labelsDisplay={labelsDisplay}
    />
  );
};

CanvasCircleDisplay['displayName'] = 'CanvasCircleDisplay';
